import * as batshit from "@yornaath/batshit";
import {AssessmentId, nominate, Finding, FindingId, FindingIdPair} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";
import {resolverFn, scheduler} from "../../batch";

function encodeIdPair(idPair: FindingIdPair): string {
  return `${idPair.assessment_id}/${idPair.finding_id}`;
}
function decodeIdPair(value: string): FindingIdPair {
  const [assessmentId, findingId] = value.split("/", 2);
  return {assessment_id: nominate("AssessmentId", assessmentId), finding_id: nominate("FindingId", findingId)};
}

const findings = batshit.create({
  fetcher: (queries: string[]) => api.tprm.findings.load(queries.map(decodeIdPair)),
  resolver: resolverFn((finding: Finding, idPair: string) => finding.finding_id === decodeIdPair(idPair).finding_id),
  scheduler,
});

export const finding = typedQuery(
  ["tprm", "finding", param<AssessmentId>("assessmentId"), param<FindingId>("findingId")],
  async (assessmentId, findingId) => {
    return await findings.fetch(encodeIdPair({assessment_id: assessmentId, finding_id: findingId}));
  },
);
